export enum ApplicationType {
  Active = 'Active',
  Automated = 'Automated',
  Hybrid = 'Hybrid'
}
